import type { GalleryImage } from "./types";

export const gallery: GalleryImage[] = [
  { src: "/images/gallery/plant-1.jpg", alt: "Kasa Chemicals facility" },
  { src: "/images/gallery/m-1.jpg", alt: "Kasa product on site" },
  { src: "/images/gallery/m-2.jpg", alt: "Stone and tile application" },
  { src: "/images/gallery/m-3.jpg", alt: "Construction chemicals in use" },
  { src: "/images/gallery/m-4.jpg", alt: "Kasa packaging" },
  { src: "/images/gallery/m-5.jpg", alt: "Waterproofing work" },
  { src: "/images/gallery/m-6.jpg", alt: "Finished stone surface" },
];
